import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { observer } from 'mobx-react';
import Icon from '../../../components/Icon';
import ProgressSpinner from '../../../components/ProgressSpinner';
import FlashMessageStore, { FlashMessageTypes } from '../../FlashMessageStore';
import './styles.sass';
var ANIMATION_DURATION = 300;
var ICONS = _defineProperty(_defineProperty(_defineProperty({}, FlashMessageTypes.SUCCESS, 'check'), FlashMessageTypes.WARN, 'exclamation-triangle'), FlashMessageTypes.ERROR, 'exclamation-triangle');

/**
 * A single item.
 */
var FlashMessageItem = observer(function FlashMessageItem(_ref) {
  var _flash$actions;
  var flash = _ref.flash;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('FlashMessage', "FlashMessage--".concat(flash.type))
  }, /*#__PURE__*/React.createElement("div", {
    className: "FlashMessage__inner"
  }, flash.type && ICONS[flash.type] && /*#__PURE__*/React.createElement("div", {
    className: "FlashMessage__type-container"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: ICONS[flash.type]
  })), flash.inProgress && /*#__PURE__*/React.createElement("div", {
    className: "FlashMessage__progress-container"
  }, /*#__PURE__*/React.createElement(ProgressSpinner, null)), /*#__PURE__*/React.createElement("div", {
    className: "FlashMessage__message-content"
  }, flash.message), /*#__PURE__*/React.createElement("div", {
    className: "FlashMessage__actions"
  }, (_flash$actions = flash.actions) === null || _flash$actions === void 0 ? void 0 : _flash$actions.map(function (action) {
    return /*#__PURE__*/React.createElement("button", {
      "data-test": "toast-action-".concat(action.label),
      key: action.label,
      onClick: function onClick() {
        action.onClick();
        flash.dismiss();
      }
    }, action.label);
  }), /*#__PURE__*/React.createElement("button", {
    "data-test": "toast-action-dismiss",
    onClick: function onClick() {
      return flash.dismiss();
    }
  }, "Dismiss"))));
});

/**
 * Flash messages container
 *
 * @param  {FlashMessageStore} options.store
 */
var FlashMessages = function FlashMessages(_ref2) {
  var store = _ref2.store,
    position = _ref2.position;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('FlashMessages', "FlashMessages--".concat(position))
  }, /*#__PURE__*/React.createElement(TransitionGroup, null, store.showingFlashes.map(function (f) {
    return /*#__PURE__*/React.createElement(CSSTransition, {
      key: f.id,
      timeout: ANIMATION_DURATION,
      appear: true,
      classNames: {
        enter: 'anim-enter',
        appear: 'anim-enter',
        exit: 'anim-leave'
      }
    }, /*#__PURE__*/React.createElement(FlashMessageItem, {
      flash: f
    }));
  })));
};
FlashMessages.propTypes = {
  store: PropTypes.instanceOf(FlashMessageStore),
  position: PropTypes.oneOf(['bottomRight', 'bottomLeft', 'topRight', 'topLeft'])
};
FlashMessages.defaultProps = {
  position: 'bottomRight'
};
export default observer(FlashMessages);
//# sourceMappingURL=index.js.map
